import { providerApi } from '@/api/ProviderApi'
import { UPCOMING_VISITS_QUERY_KEY } from '@/api/hooks/useFetchUpcomingVisits'
import { useMutation, useQueryClient } from '@tanstack/react-query'

/**
 * Checking in, and the list catching up.
 *
 * The response is the visit's new check-in block, so the screen could redraw from it alone —
 * but the list is what the screen actually reads, and a visit whose card says "Checked In"
 * while the Home tile behind it does not is the kind of disagreement a member notices. The
 * invalidation is the cheaper fix, and the response still matters: it decides what to say
 * without waiting for the refetch.
 */
export const useCheckInAppointment = () => {
	const queryClient = useQueryClient()

	return useMutation({
		mutationFn: ({ appointmentId }: { appointmentId: number }) =>
			providerApi.checkInAppointment(appointmentId),
		onSuccess: () => {
			queryClient.invalidateQueries({ queryKey: UPCOMING_VISITS_QUERY_KEY })
		},
	})
}
